<template>
  <b-card no-body
          class="mb-1 border-0"
  >
    <b-card-header header-tag="header"
                   class="p-0 border-0"
                   role="tab"
    >
      <b-button block
                variant="primary"
      >
        <i class="fa fa-list-ol"/>
        NIVELES DE UBICACIÓN
      </b-button>
    </b-card-header>
    <b-card-body class="py-3 px-0">
      <b-row>
        <b-col sm="8">
          <b-form-group>
            <b-input-group>
              <b-form-input name="nombre"
                            type="text"
                            placeholder="Buscar..."
                            v-model="filtro_niveles.descripcion"
                            class="text-uppercase"
                            @keypress.enter="listarNiveles"
              />
              <b-input-group-append>
                <b-button variant="primary"
                          @click.prevent="listarNiveles"
                >
                  <i class="fa fa-search fa-lg"/>
                  <span class="d-none d-md-inline-block">Buscar</span>
                </b-button>
                <b-button @click="limpiarNiveles">
                  <i class="fa fa-eraser fa-lg"/>
                  <span class="d-none d-md-inline-block"> Limpiar</span>
                </b-button>
              </b-input-group-append>
            </b-input-group>

          </b-form-group>
        </b-col>

        <b-col sm="4">
          <b-button variant="primary"
                    class="float-right"
                    @click="mostrarModalNiveles('Crear')"
          >
            Nuevo
          </b-button>
        </b-col>
      </b-row>

      <b-row>
        <b-col sm="12">
          <b-table responsive
                   striped
                   hover
                   small
                   :items="niveles"
                   :fields="columnas"
                   thead-tr-class="table-active"
                   class="mb-0"
                   empty-text="No hay niveles para mostrar"
                   show-empty
          >
            <template v-slot:cell(estado)="data">
              <b-badge v-if="data.item.activo"
                       variant="primary"
                       v-text="'Activa'"
              />
              <b-badge v-else
                       variant="danger"
                       v-text="'Inactiva'"
              />
            </template>

            <template v-slot:cell(actions)="data">
              <a v-b-tooltip.hover
                 class="botonProduct text-dark mr-3"
                 title="Editar"
                 @click="editarNivel(data.item)"
              >
                <i class="fa fa-edit"></i>
              </a>
              <a v-b-tooltip.hover
                 class="botonProduct"
                 :title="!!data.item.activo ? 'Inactivar' : 'Activar'"
                 @click="eliminarNivel(data.item)"
              >
                <i class="fa fa-close text-danger"
                   v-if="!!data.item.activo"
                />
                <i class="fa fa-check text-success"
                   v-else
                />
              </a>
            </template>
          </b-table>
        </b-col>
      </b-row>
    </b-card-body>


    <b-modal v-model="modal_niveles.ver"
             :title="accion_niveles + ' nivel'"
             hide-footer
    >
      <form @submit.prevent="validarFormularioNiveles"
            data-vv-scope="niveles"
      >
        <b-row>
          <b-col sm="12">
            <b-form-group>
              <label for="descripcion">Nivel de Ubicación</label>
              <b-form-input type="text"
                            id="descripcion"
                            name="descripcion"
                            data-vv-as=" "
                            class="text-uppercase"
                            v-validate="'required|min:3|max:30'"
                            v-model="selectedNivel.descripcion"
              />
              <span class="text-danger span-error small">{{ errors.first('niveles.descripcion') }}</span>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col class="text-center">
            <hr>
            <b-button @click="validarFormularioNiveles"
                      size="sm"
                      variant="primary"
            >
              <i class="fa fa-floppy-o fa-lg"></i> Guardar
            </b-button>
          </b-col>
        </b-row>
      </form>
    </b-modal>
  </b-card>
</template>

<script>
import {mapActions, mapMutations, mapState} from 'vuex';

export default {
  name: 'niveles',
  data() {
    return {
      columnas: [
        {
          key: 'nivel',
          label: 'Nivel',
          sortable: true,
          tdClass: 'text-center',
          thClass: 'text-center',
          thStyle: 'width: 80px; max-width:80px'
        },
        {
          key: 'descripcion',
          label: 'Descripción',
          tdClass: 'text-uppercase',
          sortable: true
        },
        {
          key: 'estado',
          label: 'Estado',
          sortable: true,
          tdClass: 'text-center',
          thClass: 'text-center',
          thStyle: 'width: 120px; max-width:120px'
        },
        {
          key: 'actions',
          label: 'Opciones',
          tdClass: 'text-center',
          thClass: 'text-center',
          thStyle: 'width: 120px; max-width:120px'
        },
      ],
    };
  },
  computed: {
    ...mapState('ubicacion', [
      'selectedNivel',
      'niveles',
      'nivelesActivos',
      'id_ubicacion',
      'filtro_niveles',
      'modal_niveles',
      'accion_niveles'
    ]),
  },
  methods: {
    ...mapActions('ubicacion', [
      'crearNivel',
      'listarNiveles',
      'updateNivel',
      'deleteNivel',
      'listarNivelActivos'
    ]),
    ...mapMutations('ubicacion', [
      'setSelectedNivel',
      'resetFiltroNiveles',
      'establecerModalNiveles',
      'establecerAccionNiveles',
      'resetSelectedNivel',
      'resetFiltroNiveles'
    ]),
    async limpiarNiveles() {
      this.resetFiltroNiveles();
      await this.listarNiveles();
    },
    mostrarModalNiveles(accion) {
      this.establecerAccionNiveles(accion);
      this.resetSelectedNivel();
      this.establecerModalNiveles(true);
    },
    async editarNivel(nivel) {
      this.mostrarModalNiveles('Actualizar');
      this.setSelectedNivel(nivel);
    },
    async validarFormularioNiveles() {
      await this.$validator.validateAll('niveles')
        .then(async (validado) => {
          if (validado) {
            if (this.accion_niveles === 'Crear') {
              await this.crearNivel(this.$route.params.id);
            } else {
              await this.updateNivel(this.$route.params.id);
            }
          }
        });
    },
    async eliminarNivel(nivel) {
      this.setSelectedNivel(nivel);
      await this.deleteNivel();
    },
  }
};
</script>

<style scoped>

</style>
